import formattedMessages from './languageModule'

export const BLOCKED_24H_MODAL = 'BLOCKED_24H_MODAL'
export const BLOCKED_USER = 'BLOCKED_USER'
export const BLOCKED_OFFLINE_APP = 'BLOCKED_OFFLINE_APP'
export const BLOCKED_MUST_UPDATE_APP = 'BLOCKED_MUST_UPDATE_APP'
export const USER_NOT_VALID = 'USER_NOT_VALID'
export const SERVICE_NOT_AVAILABLE = 'SERVICE_NOT_AVAILABLE'
export const BLOCKED_USER_SUSPEND = 'BLOCKED_USER_SUSPEND'
export const BLOCKED_USER_REVOKE = 'BLOCKED_USER_REVOKE'
export const BLOCKED_ROOTED_APP = 'BLOCKED_ROOTED_APP'
export const BLOCKED_SSL_INVALID_APP = 'BLOCKED_SSL_INVALID_APP'
export const REG_ACCOUNT_DISABLED = 'REG_ACCOUNT_DISABLED'
export const REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL = 'REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL'
export const BLOCKED_MFA_MODAL = 'BLOCKED_MFA_MODAL'

export const configBlockedPopup = Object.freeze({
  [BLOCKED_24H_MODAL]: {
    title: formattedMessages.blockedModal24HoursTitle,
    description: formattedMessages.blockedModal24HoursDescription,
    labelButton: formattedMessages.labelButton
  },
  [BLOCKED_MFA_MODAL]: {
    title: formattedMessages.blockedMFATitle,
    description: formattedMessages.blockedModal24HoursDescription,
    labelButton: formattedMessages.labelButtonExit
  },
  [BLOCKED_USER]: {
    title: formattedMessages.blockedModalTitle,
    description: formattedMessages.blockedModalDescription,
    labelButton: formattedMessages.labelButton
  },
  [USER_NOT_VALID]: {
    title: formattedMessages.blockedModalUserNotValidTitle,
    description: formattedMessages.blockedModalUserNotValidDescription,
    labelButton: formattedMessages.labelButton
  },
  [SERVICE_NOT_AVAILABLE]: {
    title: formattedMessages.blockedModalServiceNotAvailableTitle,
    description: formattedMessages.blockedModalServiceNotAvailableDescription,
    labelButton: formattedMessages.labelButton
  },
  [BLOCKED_USER_SUSPEND]: {
    title: 'La tua utenza è stata sospesa',
    description: 'Per maggiori informazioni contatta l’amministratore del Portale.',
    labelButton: formattedMessages.labelButton
  },
  [BLOCKED_USER_REVOKE]: {
    title: 'La tua utenza è stata revocata',
    description: 'Per maggiori informazioni contatta l’amministratore del Portale.',
    labelButton: formattedMessages.labelButton
  },
  [REG_ACCOUNT_DISABLED]: {
    title: formattedMessages.blockedModalAccountDisabledTitle,
    description: formattedMessages.blockedModalAccountDisabledDescription,
    labelButton: formattedMessages.understandButton
  },
  [REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL]: {
    title: formattedMessages.regVatEmailAppemptsErrorModalTitle,
    description: formattedMessages.regVatEmailAppemptsErrorModalDescription,
    labelButton: formattedMessages.understandButton
  },
  [BLOCKED_OFFLINE_APP]: {
    title: formattedMessages.appOfflineModalTitle,
    description: formattedMessages.appOfflineModalDescription,
    labelButton: formattedMessages.tryAgain
  },
  [BLOCKED_MUST_UPDATE_APP]: {
    title: formattedMessages.appToUpdateModalTitle,
    description: formattedMessages.appToUpdateModalDescription,
    labelButton: formattedMessages.goToStore
  },
  [BLOCKED_ROOTED_APP]: {
    title: formattedMessages.appRootedModalTitle,
    description: formattedMessages.appRootedModalDescription
  },
  [BLOCKED_SSL_INVALID_APP]: {
    title: formattedMessages.appSslInvalidModalTitle,
    description: formattedMessages.appSslInvalidModalDescription
  }
})
